import bindAllMethods from '../../../utils/bindAllMethods';
import { getServices } from '../../../infra/startup';
import { GrantsInterfaceType } from '@clientos/types';
import { IGrantService } from '../../../services/grants/IGrantService';
import { GrantOptionsType, GrantType } from '../../../services/grants/types';

export class GrantsInterfaceV1 {
  private grantService: IGrantService;

  constructor() {
    const services = getServices();
    this.grantService = services.grantService;

    bindAllMethods(this);
  }

  getInterface(): GrantsInterfaceType {
    return {
      refresh: this.refresh,
      checkGrants: this.checkGrants,
      checkPendingGrants: this.checkPendingGrants,
      useReactCheckGrants: this.useReactCheckGrants,
      useReactCheckPendingGrants: this.useReactCheckPendingGrants
    };
  }

  private async refresh(options?: GrantOptionsType): Promise<void> {
    return this.grantService.refresh(options);
  }

  private async checkGrants(
    grants: GrantType[],
    options?: GrantOptionsType
  ): Promise<boolean> {
    return this.grantService.checkGrants(grants, options);
  }

  private async checkPendingGrants(
    grants: GrantType[],
    options?: GrantOptionsType
  ): Promise<boolean> {
    return this.grantService.checkPendingGrants(grants, options);
  }

  private useReactCheckGrants(
    _React: any,
    grants: GrantType[],
    options?: GrantOptionsType
  ): {
    data?: boolean;
    error?: Error;
    loading: boolean;
    reload: () => Promise<void>;
  } {
    return this.grantService.useReactCheckGrants(_React, grants, options);
  }

  private useReactCheckPendingGrants(
    _React: any,
    pendingGrants: GrantType[],
    options?: GrantOptionsType
  ): {
    data?: boolean;
    error?: Error;
    loading: boolean;
    reload: () => Promise<void>;
  } {
    return this.grantService.useReactCheckPendingGrants(
      _React,
      pendingGrants,
      options
    );
  }
}
